import { Component } from "react";

import { type IEmptyStateEntityBannerProps } from "commonComponents/entity/emptyState/common/EmptyState.api.types";
import { EmptyStateBanner } from "commonComponents/entity/emptyState/EmptyStateBanner";

import { getBillEmptyStateDescription, getBillEmptyStateTitle } from "./BillEmptyState";

interface IBillEmptyStateBannerProps extends IEmptyStateEntityBannerProps {}

export class BillEmptyStateBanner extends Component<IBillEmptyStateBannerProps> {
    private getInitialWithDataState = () => {
        return <>{getBillEmptyStateDescription()}</>;
    };

    render() {
        const { actionBeingPerformed, onDismiss, isDismissed, hasListData } = this.props;

        if (isDismissed || !hasListData) {
            return null;
        }

        return (
            <EmptyStateBanner
                title={getBillEmptyStateTitle()}
                actionBeingPerformed={actionBeingPerformed}
                onDismiss={onDismiss}
                isDismissable={true}
            >
                {this.getInitialWithDataState()}
            </EmptyStateBanner>
        );
    }
}
